// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: sticky;
  top: 0;
  z-index: 50;
  background: var(--brand-primary);
  color: var(--text-on-dark);
  box-shadow: var(--shadow-sm);
}

.navbar__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.75rem 1.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.navbar__brand {
  display: inline-flex;
  align-items: center;
  color: var(--text-on-dark);
  transition: color var(--transition);
}

.navbar__brand:hover {
  color: var(--interactive-hover);
}

.navbar__menu {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.navbar__links {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  list-style: none;
}

.navbar__link {
  position: relative;
  padding: 0.5rem 0;
  color: var(--text-on-dark);
  font-weight: 500;
  transition: color var(--transition);
}

.navbar__link::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: var(--interactive);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform var(--transition);
}

.navbar__link:hover,
.navbar__link--active {
  color: var(--interactive);
}

.navbar__link:hover::after,
.navbar__link--active::after {
  transform: scaleX(1);
}

.navbar__link:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 4px;
  border-radius: var(--radius-sm);
}

.navbar__burger {
  display: none;
  margin-left: auto;
  flex-direction: column;
  gap: 5px;
  padding: 0.5rem;
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
}

.navbar__burger span {
  width: 24px;
  height: 2px;
  background: var(--interactive);
  transition:
    transform var(--transition),
    opacity var(--transition);
}

.navbar__burger--open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.navbar__burger--open span:nth-child(2) {
  opacity: 0;
}
.navbar__burger--open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

@media (max-width: 720px) {
  .navbar__burger {
    display: inline-flex;
  }

  .navbar__menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
    padding: 1rem 1.25rem 1.5rem;
    background: var(--brand-primary);
    box-shadow: var(--shadow);
    transform: translateY(-8px);
    opacity: 0;
    pointer-events: none;
    transition:
      transform var(--transition),
      opacity var(--transition);
  }

  .navbar__menu--open {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }

  .navbar__links {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B;;6BAE2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,UAAU;AACZ;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,4BAA4B;IAC5B,gCAAgC;IAChC,yBAAyB;IACzB,2BAA2B;IAC3B,UAAU;IACV,oBAAoB;IACpB;;+BAE2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;AACF","sourcesContent":[".navbar {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  background: var(--brand-primary);\n  color: var(--text-on-dark);\n  box-shadow: var(--shadow-sm);\n}\n\n.navbar__inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0.75rem 1.25rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.navbar__brand {\n  display: inline-flex;\n  align-items: center;\n  color: var(--text-on-dark);\n  transition: color var(--transition);\n}\n\n.navbar__brand:hover {\n  color: var(--interactive-hover);\n}\n\n.navbar__menu {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.navbar__links {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  list-style: none;\n}\n\n.navbar__link {\n  position: relative;\n  padding: 0.5rem 0;\n  color: var(--text-on-dark);\n  font-weight: 500;\n  transition: color var(--transition);\n}\n\n.navbar__link::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  background: var(--interactive);\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform var(--transition);\n}\n\n.navbar__link:hover,\n.navbar__link--active {\n  color: var(--interactive);\n}\n\n.navbar__link:hover::after,\n.navbar__link--active::after {\n  transform: scaleX(1);\n}\n\n.navbar__link:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 4px;\n  border-radius: var(--radius-sm);\n}\n\n.navbar__burger {\n  display: none;\n  margin-left: auto;\n  flex-direction: column;\n  gap: 5px;\n  padding: 0.5rem;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: var(--radius-sm);\n}\n\n.navbar__burger span {\n  width: 24px;\n  height: 2px;\n  background: var(--interactive);\n  transition:\n    transform var(--transition),\n    opacity var(--transition);\n}\n\n.navbar__burger--open span:nth-child(1) {\n  transform: translateY(7px) rotate(45deg);\n}\n.navbar__burger--open span:nth-child(2) {\n  opacity: 0;\n}\n.navbar__burger--open span:nth-child(3) {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n@media (max-width: 720px) {\n  .navbar__burger {\n    display: inline-flex;\n  }\n\n  .navbar__menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n    padding: 1rem 1.25rem 1.5rem;\n    background: var(--brand-primary);\n    box-shadow: var(--shadow);\n    transform: translateY(-8px);\n    opacity: 0;\n    pointer-events: none;\n    transition:\n      transform var(--transition),\n      opacity var(--transition);\n  }\n\n  .navbar__menu--open {\n    transform: translateY(0);\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .navbar__links {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
